export default __webpack_public_path__ + "static/media/PRZYLOZ_PONOWNIE_OPASKE.4b2f4ffb.png";